<template>
  <div class="row row-equal">
    <div class="flex xs12">
      <div class="row">
        <div
          class="flex xs12 sm2"
          v-for="(info, idx) in infoTiles"
          :key="idx"
        >
          <va-card class="mb-4" :color="cardColor">
            <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ info.value }}</p>
            <p :style="`color: ${$themes.primary}`">{{ info.text }}</p>
          </va-card>
        </div>
      </div>
      <!-- vehicles -->
      <div class="row">
        <div class="flex xs12">
          <va-card>
            <div class="row row-separated">
              <div class="flex xs12 sm3"
                v-for="(info, idx) in infoVehicles"
                :key="idx"
              >
                <p class="display-2 mb-1 text--center" :style="`color: ${$themes.secondary}`">{{info.quantity}}</p>
                <p class="text--center mb-1" :style="`color: ${$themes.secondary}`">{{info.name}}</p>
              </div>
            </div>
          </va-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import IndicatoresAPI from '@/services/IndicatoresAPI'
import { EventBus } from '@/event-bus'
import { mapState } from "vuex";

export default {
  name: 'DashboardInfoBlock',
  data () {
    return {
      cardColor: 'secondary',
      textCardColor: 'primary',
      infoTiles: [],
      infoVehicles: [],
    }
  },

  computed: {
    ...mapState(['currentLocality']),
  },

  methods: {
    readItems(new_date){
      IndicatoresAPI.getOrdersIndicatores(new_date, this.currentLocality.id).then(response => {
        this.infoTiles = response.data.order_indicators.map(item => ({ value: item.quantity, text: item.name }))
      })

      IndicatoresAPI.getVehiclesIndicatores(new_date, this.currentLocality.id).then(response => {
        this.infoVehicles = response.data.vehicle_indicators
      })

      // IndicatoresAPI.getPercentaulsIndicatores(new_date, this.currentLocality.id).then(response => {
      //   this.infoPercentuals = response.data.percentual_indicators
      // })

    }
  },

  mounted () {
    this.readItems('')

    EventBus.$on('dashborad_delivery_date_changed', new_date => {
      this.readItems(new_date)
    });
  },

  beforeDestroy(){
    EventBus.$off('dashborad_delivery_date_changed');
  }
}
</script>

<style lang="scss">
  .row-separated {
    .flex + .flex {
      border-left: 1px solid #e3eaeb;
    }

    @include media-breakpoint-down(xs) {
      p:not(.display-2){
        font-size: 0.875rem;
      }
    }
  }

  .dashboard {
    .va-card__header--over {
      @include media-breakpoint-up(md) {
        padding-top: 0 !important;
      }
    }

    .va-card__image {
      @include media-breakpoint-up(md) {
        padding-bottom: 0 !important;
      }
    }
  }
</style>
